<template>
  <div class="product-recommended">
    <div class="product-recommended__items">
      <div class="product-recommended__items__product">
        <img
          class="product-recommended__items__product__package"
          src="/img/package.svg"
          alt="package"
        />
        <div class="product-recommended__items__product__name">
          <span>Nome do produto</span>
        </div>
        <div class="product-recommended__items__product__price">
          <AmTypography
            typography-style="l4"
            weight="bold"
          >
            <span>R$99,00</span>
          </AmTypography>
        </div>
        <AmButton
          :class="`${theme.color} button__outlined--${theme.color}`"
          :label="$t('containerRigth.requests.purchase.buttonLabel')"
          size="md"
          full-width
          :icon="iconPurchaseProduct"
          type="outlined"
        />
      </div>
    </div>
  </div>
</template>

<script>
import themeMixin from '@/components/mixins/themeMixin'

export default {
  name: 'ProductRecommended',
  mixins: [themeMixin],
  data() {
    return {
      iconPurchaseProduct: {
        name: 'add_shopping_cart',
        position: 'left',
        type: 'material',
        size: 'xl',
        color: '#0083f3',
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.product-recommended {
  &__items {
    display: flex;
    justify-content: space-evenly;
    width: 100%;
    &__product {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      .items__product__package {
        width: 70px;
        height: auto;
        margin: 12px;
      }
      &__price {
        margin: 10px 0 10px 0;
      }
      &__price span {
        color: $error-120;
      }
    }
  }
}
</style>
